import { get } from './api.js';

let cfg = null;

export async function loadConfig() {
  if (cfg) return cfg;
  cfg = await get('/config');
  return cfg;
}

export function getConfig() {
  return cfg;
}
